<template>
  <label class="text-neutral-100 text-pararaphy-2">
    <slot></slot>

    <span v-if="required" class="text-alert-error">*</span>
  </label>
</template>

<script setup>
const props = defineProps({ required: Boolean })
</script>

<style lang="scss" scoped></style>
